import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/SectionHeading';
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="mx-auto max-w-4xl px-4 py-12 md:py-16" data-id="element-67" data-mp="1gdh03dreuk2q">
      <Eyebrow data-id="element-68" data-mp="2e0fxjqpxfw1o">
        <span className="inline-flex items-center gap-2" data-id="element-69" data-mp="2e0zhfcz50uic">
          <HelpCircleIcon aria-hidden="true" className="h-4 w-4" data-id="element-70" data-mp="2dydanfk2mj16" /> Preguntas frecuentes
        </span>
      </Eyebrow>
      <SectionTitle data-id="element-71" data-mp="28zielbx3exz4">
        Lo que más <span className="text-gold" data-id="element-72" data-mp="241h0z6ifrqv1">nos preguntan</span>
      </SectionTitle>
      <div className="mt-10 space-y-3" data-id="element-73" data-mp="1z3fhikh3lpj1">
        {faqs.map(([question, answer], index) => {
        const isOpen = open === index;
        return <div key={question} className={`overflow-hidden rounded-2xl border bg-surface transition-colors duration-150 ease-smooth ${isOpen ? 'border-gold/60' : 'border-line'}`} data-id="element-74" data-mp="soo9zxxgz6g1" data-mpi={index}>
              <h3 data-id="element-75" data-mp="uhkg3xw5fq4t">
                <button type="button" className="flex w-full items-center justify-between gap-3 p-5 text-left font-bold text-white md:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-76" data-mp="ufzj81md3v3s">
                  {question}
                  <ChevronDownIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-180' : ''}`} data-id="element-77" data-mp="6q57xohoyeln" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-78" data-mp="1q0q9v51rdtu">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-79" data-mp="3jyrtytfbf2fu">
                    <p className="border-t border-line px-5 py-4 text-sm font-medium leading-relaxed text-zinc-400 md:px-6" data-id="element-80" data-mp="1potdwkehv35a">
                      {answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}